<template>
    <div class="block-editor assign-owner">
        <section>
            <div class="title">{{ $t('auto.assignOwnerContactId') }}</div>
            <TiptapEditor placeholder="Contact ID" :show-attributes="true" v-model="clone.contactId" automation-mode />
        </section>
        <section>
            <div class="title">{{ $t('auto.assignOwnerAtamaYNtemi') }}</div>
            <a-select v-model="clone.method" class="classic-select">
                <a-select-option value="algorithmic">{{ $t('auto.assignOwnerAlgoritmikAtama') }}</a-select-option>
                <a-select-option value="static">{{ $t('auto.assignOwnerStatikAtama') }}</a-select-option>
            </a-select>
        </section>
        
        <section v-if="clone.method === 'static'">
            <div class="title">{{ $t('auto.assignOwnerAtanacakTemsilci') }}</div>
            <a-select v-model="clone.staticUserId" class="classic-select" :placeholder="$t('auto.assignOwnerTemsilciSeIniz')" allow-clear>
                <a-select-option :value="null">{{ $t('auto.assignOwnerSahipsizOwnerKaldR') }}</a-select-option>
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t('auto.assignOwnerSeIlenTemsilciChannelVeDepartmentAyarlarNaUygunOlmalDR') }}</small>
        </section>
        
        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t('auto.assignOwnerAlgoritma') }}</div>
            <a-select v-model="clone.algorithm" class="classic-select">
                <a-select-option value="least_contact">{{ $t('auto.assignOwnerEnAzKontaASahipOlan') }}</a-select-option>
                <a-select-option value="random">{{ $t('auto.assignOwnerRastgele') }}</a-select-option>
            </a-select>
        </section>
        
        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t('auto.assignOwnerTarihAral') }}</div>
            <a-select v-model="clone.dateRange" class="classic-select">
                <a-select-option value="today">{{ $t('auto.assignOwnerBugN') }}</a-select-option>
                <a-select-option value="last_7_days">{{ $t('auto.assignOwnerSon7GN') }}</a-select-option>
                <a-select-option value="last_30_days">{{ $t('auto.assignOwnerSon30GN') }}</a-select-option>
            </a-select>
            <small>{{ $t('auto.assignOwnerTemsilcilerinSahipOlduUKontakSayLarNaBakLacakZamanAral') }}</small>
        </section>
        
        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t('auto.assignOwnerSadeceOnlineOlanlaraDaT') }}</div>
            <a-switch v-model="clone.checkOnlineStatus" />
        </section>
        
        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t('auto.assignOwnerHariTutulacakTemsilciler') }}</div>
            <a-select v-model="clone.excludeUserIds" mode="multiple" class="classic-select">
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t('auto.assignOwnerSeIlenTemsilcilerAtamaHavuzundanHariTutulacaktR') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "AssignOwner",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                method: "algorithmic", // geri dönük uyumluluk için default
                ...this.value
            }),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.assign-owner {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
